export default "__VITE_ASSET__CdawE_MC__"